module.exports = __webpack_public_path__ + "static/media/Other-Square.a72cb116.jpg";